import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';
import { Extras } from './Extras';
import { ExtrasWrapper } from './ExtrasSection.styles';
import { usePackageConfiguration } from '../../contexts';

export const ExtrasSection = () => {
  const { availableExtras = [] } = usePackageConfiguration();
  const { watch, setValue } = useFormContext();

  const selectedExtras = watch('extras') || [];

  useEffect(() => {
    if (!availableExtras) {
      return;
    }
    const extrasWithIsSelected = availableExtras.map((extra) => ({
      ...extra,
      isSelected: false,
      quantity: 1,
    }));
    // Prevents removing selected options when return to this step
    if (selectedExtras.length === 0) {
      setValue('extras', extrasWithIsSelected);
    }
  }, []);

  return (
    <ExtrasWrapper>
      <Extras extras={availableExtras} selectedExtras={selectedExtras} />
    </ExtrasWrapper>
  );
};
